<template>
	<section>
		<el-drawer direction="rtl" :visible.sync="visibleCompress" size="40%" @close="closeCompress">
			<el-row style="padding:20px;" v-loading="zipLoading" :element-loading-text="'压缩中'+process_number+'%'"
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
				<el-form style="height:100%" :linline="false">
					<el-form-item label="选择学年">
						<select-year v-model="filters.year" />
					</el-form-item>
					<el-form-item label="选择学期">
						<select-term v-model="filters.term" />
					</el-form-item>

					<!-- <el-form-item label="选择作者">
                        <el-select v-model="author" filterable clearable placeholder="选择作者" :disabled="zipLoading">
                            <el-option :label="user.name" :value="user.user_id" v-for="(user,index) in user_List" :key="index"></el-option>
                        </el-select>
                    </el-form-item> -->
					<el-row style="">
						<el-tree :data="tree_list" :props="{label:'name',children:'children'}"
							@check-change="currentChange" node-key="id" show-checkbox :filter-node-method="filterNode1"
							:check-on-click-node="false" class="objectTree" ref="treeSelect">

							<span slot-scope="{node,data}" class="custom-tree-node" style="display:flex;">
								<span style="font-size:16px;" :style="!data.allow?'color:#cccccc':''">
									<svg data-v-7eb2bc79 :aria-hidden=true class="icon"
										v-if="node.childNodes.length!=0">
										<use data-v-7eb2bc79
											:xlink:href="node.expanded?'#icon-wenjianjia3':'#icon-wenjianjia2'"></use>
									</svg>
									<svg data-v-7eb2bc79 :aria-hidden=true class="icon" v-else>
										<use data-v-7eb2bc79
											:xlink:href="node.expanded?'#icon-wenjianjia1':'#icon-iconset0196'"></use>
									</svg>
									<span>{{data.id==null?'全部' : node.label }}</span>
								</span>
							</span>
						</el-tree>
					</el-row>
				</el-form>
			</el-row>

			<div class="demo-drawer-footer1" style="width:40%">
				<el-button style="margin-right:30px" @click="closeCompress()">关闭</el-button>
				<el-button type="primary" @click="toCompress()" :loading="zipLoading">点击下载</el-button>
			</div>
		</el-drawer>
	</section>
</template>

<script>

	import { oa_catalog } from "@/api/server";
	import SelectYear from '../select-year.vue';
	import SelectTerm from '../select-term.vue';
	import { mapState } from 'vuex'
	export default {
		props: ['user_List', 'tree_list'],
		data() {
			return {
				filterText1: '',
				visibleCompress: false,
				props: { label: "name", children: 'children' },
				catalog_list: [],
				filters: {
					year: null,
					term: 0
				},
				author: null,
				zipLoading: false,
				process_number: 0,
			}
		},

		components: {
			SelectYear,
			SelectTerm
		},
		computed: {
			...mapState('school', ['schoolDate'])
		},

		watch: {
			filterText1(val) {
				this.$refs.treeSelect.filter(val);
			},
		},

		methods: {
			filterNode1(value, data) {
				if (!value) return true;
				return data.name.indexOf(value) !== -1;
			},
			currentChange(data, value) {
				if (!data.id) {
					this.tree_list.forEach(v => {
						if (v.id && v.allow) {
							this.$refs.treeSelect.setChecked(v.id, value, true)
						}
					})
				} else if (!data.allow) {
					this.$message({ message: "暂无权限!", type: "info" });
					this.$refs.treeSelect.setChecked(data.id, false, true)
				}
			},
			openCheckTree() {
				this.$nextTick(() => {
					this.$refs.tree_listRef.openAllTree();
				});
			},

			closeCompress() {
				this.visibleCompress = false
			},
			toCompress() {

				let items = this.$refs.treeSelect.getCheckedNodes()
				items = items.filter(e => e.id)
				if (items && items.length > 0) {
					this.filters.catalog_ids = items.map(r => r.id).filter(e => e)
					this.zipLoading = true;
					oa_catalog.compress(this.filters).then(res => {
						if (res.data) {
							this.is_complete(res.data.path, res.data.url);
						} else {
							this.zipLoading = false;
						}
					})
				} else {
					this.$message({ message: "请选择目录!", type: "info" });
				}
			},

			is_complete(path, url) {
				var xhr = new XMLHttpRequest();
				let time = 0;  //计时，超过10分钟停止定时器
				let that = this;

				// 创建定时器
				let iCount = setInterval(function () {
					if (time == 600) {
						clearInterval(iCount);
						that.$confirm('压缩时间超时，请重试！', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							that.is_complete(path, url);
						}).catch(() => {
							that.$message('压缩文件失败！');
							that.visibleCompress = false
							that.zipLoading = false;
						});
					}
					time = time + 1;

					oa_catalog.compressComplete({ path: path }).then(res => {
						that.process_number = res.data;
						if (res.data == 100) {
							clearInterval(iCount);
							that.visibleCompress = false;
							that.zipLoading = false;
							that.$message({ message: "压缩成功!", type: "success" });
							that.tree_list.forEach(v => {
								that.$refs.treeSelect.setChecked(v, false, true)
							})
							window.open(url)
						} else if (res.code == 10000) {
							clearInterval(iCount);
							that.visibleCompress = false
							that.zipLoading = false;
							that.$alert('压缩文件失败！', '提示', { confirmButtonText: '确定', });
						}
					})
				}, 2000);
			},

			filterNode1(value, data) {
				if (!value) return true;
				return data.name.indexOf(value) !== -1;
			},

			openAllTree() {
				this.visibleCompress = true;
				this.term_id = this.current_term_id
				this.process_number = 0;
			}
		},

		mounted() {

			this.filters.year = this.schoolDate.year || new Date().getFullYear() - 1


		}

	}
</script>

<style scoped lang="scss">
	.checked-select {
		color: #17ad9f;
		font-weight: bold;
	}
	.el-tree /deep/.custom-tree-node {
		display: flex;
	}
</style>


// WEBPACK FOOTER //
// src/components/catalog/compress.vue